export const DEFAULT_PERMISSIONS_COLLECTIONS = 'default-permissions';